import React from 'react';
import { Link } from 'react-router-dom';

import { useEffect } from 'react';

import MeetupsThumb01 from '../../images/meetups-thumb-01.jpg';
import UserImage01 from '../../images/avatar-01.jpg';

function DashboardSingleCard({id, mediaContent, lastUpdated, title, textContent, likes, state,
                               updateContentState, cardLiked}) {

  useEffect(() => {}, [mediaContent]);

  return (

    <article key={id} className="flex bg-white shadow-1 rounded-sm border border-slate-200 overflow-hidden hover:bg-yellow-50
    hover:border-yellow-400">

      {/* Image */}
      <div className="relative flex-none w-56 cursor-pointer" onClick={()=>updateContentState(state)}>
        {/*<img
          className="absolute object-cover object-center w-full h-full"
          src={mediaContent}
          width="220"
          height="236"
          alt="Meetup 01" />*/}
        <video className="absolute object-cover object-center w-full h-full" loop="loop" autoPlay="autoplay" muted>
          <source
            src={mediaContent}
            type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* Content */}
      <div className="grow p-5 flex flex-col">
        <div className="grow cursor-pointer" onClick={()=>updateContentState(state)}>
          <div className="text-sm font-semibold text-pink-500 uppercase mb-2">{lastUpdated}</div>
          <div className="inline-flex mb-2">
            <h3 className="text-lg font-bold text-slate-800">{title}</h3>
          </div>
          <div className="text-sm">{textContent}</div>
        </div>
        {/* Footer */}
        <div className="flex justify-between mt-3">
          {/* Tag */}
          <div className="text-xs inline-flex items-center font-medium bg-slate-100 text-slate-600 rounded-full text-center px-2.5 py-1">
            {/*<div className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">notifications</div>*/}
          </div>
          {/* Likes */}
          <div className="flex items-center hover:text-red-500">
            <div className="text-slate-100 bg-slate-900 bg-opacity-60 rounded-full cursor-pointer" onClick={()=>cardLiked(id, likes)}>
              <span className="sr-only">Like</span>
              <svg className="h-8 w-8 fill-current" viewBox="0 0 32 32">
                <path d="M22.682 11.318A4.485 4.485 0 0019.5 10a4.377 4.377 0 00-3.5 1.707A4.383 4.383 0 0012.5 10a4.5 4.5 0 00-3.182 7.682L16 24l6.682-6.318a4.5 4.5 0 000-6.364zm-1.4 4.933L16 21.247l-5.285-5A2.5 2.5 0 0112.5 12c1.437 0 2.312.681 3.5 2.625C17.187 12.681 18.062 12 19.5 12a2.5 2.5 0 011.785 4.251h-.003z" />
              </svg>
            </div>
            <div className="text-xs font-medium text-slate-400 italic">{likes}</div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default DashboardSingleCard;